export default "__VITE_ASSET__DRDWcpp4__"